import { Stack } from 'component-library';
import React from 'react';

import { useSelectedRecommendationCard } from '@/components/CoPilot/CoPilotContextProvider';
import { IconButtonWidget } from '@/components/widgets/a/Button/IconButton';
import { CardLayout } from '@/components/widgets/a/Card/Card';
import { getStylesByCardType } from '@/components/widgets/a/Card/utils/getStylesByCardType';
import { PillWidget } from '@/components/widgets/a/Pill/Pill';
import { Body, Footer, Header } from '@/components/widgets/a/Text/Text';
import { RecommendationCard } from '@/components/widgets/o/RecommendationCard/types';

export const RecommendationCardWidget = (recommendationCard: RecommendationCard) => {
  const selectRecommendationCard = useSelectedRecommendationCard();

  const { type, pill, header, body, footer, styles } = recommendationCard;

  const handleSelectRecommendationCard = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    selectRecommendationCard?.(recommendationCard);
  };

  const handleCardClick = () => {
    selectRecommendationCard?.(recommendationCard);
  };

  const cardStyles = styles ?? getStylesByCardType(type);

  return (
    <CardLayout
      showDivider
      onClick={handleCardClick}
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick();
        }
      }}
      role='button'
      tabIndex={0}
    >
      <Stack direction='row' className='justify-between' centerMain>
        {pill && <PillWidget styles={cardStyles} className='whitespace-normal' {...pill} />}
        <IconButtonWidget
          icon='ri-arrow-right-s-line'
          variant='text'
          size='large'
          className='px-1 py-0.5 w-fit'
          onClick={handleSelectRecommendationCard}
        />
      </Stack>
      {header && <Header text={header?.text} className={header?.withColor ? `text-[${cardStyles.color}]` : ''} />}
      {body && <Body>{body?.collapsed?.text && <span>{body.collapsed.text}</span>}</Body>}
      {footer && (
        <Footer className='empty:hidden'>
          {footer.text && <span className='font-semibold'>{footer.text}</span>}
          {footer.value && (
            <span className={cardStyles.color ? `text-[${cardStyles.color}]` : 'text-black-100'}>{footer.value}</span>
          )}
        </Footer>
      )}
    </CardLayout>
  );
};
